import { REFERRAL_CODE_VALIDATION_API } from '../utility/constants';

export const getReferralCodeStatus = async (referralCode) => {
  try {
    const res = await fetch(`${REFERRAL_CODE_VALIDATION_API}=${referralCode}`);
    const data = await res.json();

    if (data.error) {
      throw data.error;
    }

    return { data };
  } catch (error) {
    return error;
  }
};
